let _recommendations = [];
const observableRecommendations = new Rx.BehaviorSubject(_recommendations);

/**
 * @ngdoc service
 * @name repositories.RecommendationsRepository
 *
 * @description
 * RecommendationsRepository
 */
const RecommendationsRepository = {

    replace(data) {

        _recommendations = data;
        observableRecommendations.onNext(_recommendations);

    },

    getAll() {

        return _recommendations;

    },

    getObservable() {

        return observableRecommendations;

    },

};

export default RecommendationsRepository;



// WEBPACK FOOTER //
// ./scripts/common/repositories/-RFC.recommendationsRepository.js